import { render, staticRenderFns } from "./SubscribeHandler.vue?vue&type=template&id=ac8c0c5e"
import script from "./SubscribeHandler.vue?vue&type=script&lang=js"
export * from "./SubscribeHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports